import React,{ useEffect, useCallback, useState } from 'react';
import { useStaticQuery, graphql } from "gatsby"
import styled from "@emotion/styled"
import Img from "gatsby-image/withIEPolyfill"
import { Link, scrollSpy } from 'react-scroll'
import breakpoints from '../../styles/breakpoints.js';
import { Link as PageLink } from 'gatsby'

const Header =(props) =>
{
  const data = useStaticQuery(graphql`
    query HeaderQuery {
      logo : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "logo.png"}) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  scrollSpy.update();
  const [isTop,setIsTop] = useState(true);
  const [isMenuToggled, setIsMenuToggled] = useState(false); 
  const { currentPage } = props
  
  const checkScrollPos = useCallback(() => {
    if(typeof window !== "undefined")
    {
      if(window.scrollY <= 100)
        setIsTop(true)
      else
        setIsTop(false)
    }
  })
  
  useEffect(() => {
    if(typeof window !== "undefined")
      window.addEventListener("scroll",checkScrollPos);

    return () => {
      if(typeof window !== "undefined")
        window.removeEventListener("scroll",checkScrollPos);
    };
  },[props])

  const scrollOption = {
    activeClass: "active",
    smooth : true,
    spy : true,
    hashSpy : false,
    offset : -60,
    duration : 500
  }
  
  return(<NavigationWrapper className={`${isTop && props.isIndex ? 'isTop' : ''} ${isMenuToggled ? 'isMenuToggled' : ''}`} isTop={isTop}>
    <Branding to="/">
      <BrandingText>超異界通信＋</BrandingText>
      <BrandingLogo>
        <Img fluid={data.logo.childImageSharp.fluid} />
      </BrandingLogo>
    </Branding>
    <MenuToggle onClick={(e) => {
      setIsMenuToggled(!isMenuToggled);
    }}>
      <span>OpenMenu</span>
    </MenuToggle>
    <Nav>
      <HeaderLink to="/#about" hovercolor={'#f5777c'} onClick={() => {setIsMenuToggled(false);}} className={currentPage === "home" ? "active" : ""}>
        <span>超異界通信＋是什麼？</span>
      </HeaderLink>
      <HeaderLink to="/member" hovercolor={'#facb35'} onClick={() => {setIsMenuToggled(false);}} className={currentPage === "member" ? "active" : ""}>
        <span>社團夥伴</span>
      </HeaderLink>
      <HeaderLink to="/#contact" hovercolor={'#65aada'}  onClick={() => {setIsMenuToggled(false);}}>
        <span>聯絡我們</span>
      </HeaderLink>
    </Nav>
  </NavigationWrapper>);

}

export default Header;

const NavigationWrapper = styled.div`
  height:90px;
  background:white;
  
  box-shadow:0px 3px 3px rgba(0,0,0,.2);
  display:flex;
  padding:0 64px;
  justify-content:space-between;
  position:fixed;
  z-index:1000;
  width:100%;
  transition: all .3s;
  left:0;

  &.isTop{
    background:transparent;
    box-shadow:none
  }

  @media all and (max-width: ${breakpoints.smMax})
  {
    padding:0 16px;
    height:60px;
  }

  @media all and (max-width: ${breakpoints.xsMax})
  {
    padding-right:0;
    &.isMenuToggled.isTop {
      background:white;
      box-shadow:0px 3px 3px rgba(0,0,0,.2);
    }
  }
`

const Nav = styled.nav`
  display:flex;

  @media all and (max-width: ${breakpoints.xsMax})
  {
    display:block;
    background:#FFFFFF;
    position:absolute;
    height:100vh;
    right:-200px;
    width:200px;
    transition: all .3s;
    padding-top:60px;
    .isMenuToggled &{
      right:0;
    }
  }
`

const MenuToggle = styled.a`
  display:none;
  width:60px;
  height:60px;
  position:relative;
  z-index:2;
  span,&:after,&:before{
    position:absolute;
    content:' ';
    display:block;
    overflow:hidden;
    text-indent: -9999px;
    width:28px;
    height:2px;
    left:16px;
    background-color:#373F49;
    transform-origin:0 2px;
    transition: all .3s;
  }

  span{
    top:29px;
  }

  &:before{
    top:19px;
  }

  &:after{
    bottom:19px;
    
  }

  .isTop &{
    span,&:after,&:before{
      background-color:#FFFFFF
    }
  }
  .isMenuToggled.isTop &{
    span,&:after,&:before{
      background-color:#373F49;
    }
  }


  .isMenuToggled &{
    span{
      opacity:0;
    }
    &:before{
      transform:rotate(45deg);
      left: 21px;
      width:29px;
    }
    &:after{
      transform:rotate(-45deg);
      left: 21px;
      width:29px;
    }
  }
  



  @media all and (max-width: ${breakpoints.xsMax})
  {
    display:block;
  }
`

const HeaderLinkScroll = styled(Link)`
  padding:0 16px;
  color: #333;
  position:relative;
  height:90px;
  display:flex;
  align-items:center;
  transition: all .3s;

  span{display:block;position:relative;z-index:2}

  @media all and (max-width: ${breakpoints.smMax})
  {
    height:60px;
  }

  &:after{
    content:' ';
    height:0;
    position:absolute;
    bottom: 0;
    width:100%;
    background:${props => props.hovercolor};
    left:0px;
    transition: all .3s;
  }

  &:hover,&.active{
    color:#FFFFFF;
    &:after{
      height:100%;
    }
  }
  

  .isTop &{
    color:#FFFFFF;
    &:after{display:none;}
    span:after{
      content:' ';
      height:3px;
      position:absolute;
      bottom: -6px ;
      width:0;
      background:#FFF;
      left:0px;
      transition: all .3s;
    }
  
    &:hover span:after,&.active span:after{
      width:100%;
    }
  }

  @media all and (max-width: ${breakpoints.xsMax})
  {
    .isMenuToggled.isTop &{
      color: #333;
      &:after{display:block;}
      &:hover,&.active{
        color:#FFFFFF;
        &:after{
          height:100%;
        }
      }
    }
  }
`

const HeaderLink = styled(PageLink)`
  padding:0 16px;
  color: #333;
  position:relative;
  height:90px;
  display:flex;
  align-items:center;
  transition: all .3s;

  span{display:block;position:relative;z-index:2}

  @media all and (max-width: ${breakpoints.smMax})
  {
    height:60px;
  }

  &:after{
    content:' ';
    height:0;
    position:absolute;
    bottom: 0;
    width:100%;
    background:${props => props.hovercolor};
    left:0px;
    transition: all .3s;
  }

  &:hover,&.active{
    color:#FFFFFF;
    &:after{
      height:100%;
    }
  }
  

  .isTop &{
    color:#FFFFFF;
    &:after{display:none;}
    span:after{
      content:' ';
      height:3px;
      position:absolute;
      bottom: -6px ;
      width:0;
      background:#FFF;
      left:0px;
      transition: all .3s;
    }
  
    &:hover span:after,&.active span:after{
      width:100%;
    }
  }

  @media all and (max-width: ${breakpoints.xsMax})
  {
    .isMenuToggled.isTop &{
      color: #333;
      &:after{display:block;}
      &:hover,&.active{
        color:#FFFFFF;
        &:after{
          height:100%;
        }
      }
    }
  }
`

const Branding = styled(PageLink)`
  font-weight:bold;
  font-size:24px;
  height:90px;
  line-height:90px;
  color: #333;
  width:200px;
  position:relative;
  .isTop &{
    color:#FFFFFF;
  }
  @media all and (max-width: ${breakpoints.smMax})
  {
    height:60px;
    line-height:60px;
  }
`

const BrandingText = styled.span`
  opacity:0;
  transition: all .3s;
  .isTop &{
    opacity:1;
  }

  @media all and (max-width: ${breakpoints.xsMax})
  {
    .isMenuToggled.isTop &{
      opacity:0;
    }
  }
`

const BrandingLogo = styled.span`
  display:block;
  opacity:1;
  transition: all .3s;
  position:absolute;
  top:10px;
  left:0;
  width:106px;
  height:70px;
  .isTop &{
    opacity:0;
  }

  @media all and (max-width: ${breakpoints.smMax})
  {
    width:60px;
    height:40px;
    
  }

  @media all and (max-width: ${breakpoints.xsMax}){
    .isMenuToggled.isTop &{
      opacity:1;
    }
  }
`